// extracted by mini-css-extract-plugin
export default {"mainContainer":"Watch_mainContainer__nJIEa"};